// packages/components/calendar/types.js
/**
 * @typedef {Object} CalendarDay
 * @property {string} date - Date in ISO format (YYYY-MM-DD)
 * @property {boolean} isCurrentMonth - Whether this day belongs to the current month
 * @property {boolean} [isToday] - Whether this day is today
 * @property {boolean} [isSelected] - Whether this day is selected
 * @property {any[]} [events] - Array of events for this day
 */

/**
 * @typedef {Object} CalendarProps
 * @property {Date} date - The currently selected date
 * @property {function} setDate - Function to update the selected date
 * @property {function} [renderDay] - Custom renderer for day cells
 * @property {function} [renderHeader] - Custom renderer for the calendar header
 * @property {function} [renderWeekdays] - Custom renderer for weekday names
 * @property {any[]} [events] - Events to display on the calendar
 * @property {Object} [viewOptions] - Options for different calendar views
 * @property {boolean} [viewOptions.showAdjacentMonths=true] - Whether to show days from adjacent months
 * @property {string} [locale='en-US'] - Locale for date formatting
 * @property {string} [className] - Additional class names for the calendar container
 */

export const VIEW_TYPES = {
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
};
